import React from "react";
import { Inbox } from "lucide-react";
import { Button } from "../ui/button";

export default function EmptyState({
  icon: Icon = Inbox,
  title,
  description,
  actionLabel,
  onAction,
  testId,
}) {
  return (
    <div
      data-testid={testId}
      className="obsidian flex flex-col items-center justify-center text-center py-14 px-6"
    >
      <div
        className="mb-4 flex h-12 w-12 items-center justify-center rounded-xl border border-brand/25 bg-brand/10 text-brand"
      >
        <Icon className="w-5 h-5" />
      </div>
      <h3 className="text-base font-display font-semibold">{title}</h3>
      {description && (
        <p className="text-sm text-muted-foreground mt-1.5 max-w-md">{description}</p>
      )}
      {actionLabel && onAction && (
        <Button
          className="mt-5"
          onClick={onAction}
          data-testid={`${testId || "empty"}-action`}
        >
          {actionLabel}
        </Button>
      )}
    </div>
  );
}
